import { Component, OnInit } from '@angular/core';
import { ActualizarMenuComponent } from '../actualizar-menu.component';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone:true,
  imports:[ActualizarMenuComponent,MatDialogModule],
  selector: 'app-dialog-update-menu',
  templateUrl: './dialog-update-menu.component.html',
  styleUrls: ['./dialog-update-menu.component.css']
})
export class DialogUpdateMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
